<div class="form-check ml-2">
    <input  type="checkbox" [(ngModel)]="isMobileUser"
    [checked]="isMobileUser" name="isMobileUser"
    #isMobileUserFlag="ngModel" class="form-check-input check5"
    id="isMobileUser"  (change)="handleCheckboxChange(isMobileUser)" [disabled]="signStatus == 'completed'"> 
    
    <label class="form-check-label label5" for="flexCheckDefault"> Sign
        via app </label>
</div>